import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/auction/light_accept.png';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 15;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.98);
`;

const StyledHeadContainer = styled.div`
	display: grid;
	grid-template-columns: 20% 60% 20%;
	padding: 20px;
	align-items: center;
`;

const StyledHeadBackSlot = styled.div`
	justify-self: start;
`;

const StyledHeadCrossSlot = styled.div`
	justify-self: end;
`;

const StyledMainContainer = styled.div`
	position: relative;
	width: 430px;
	margin: 0 auto;
	padding: 10px 0 20px;
`;

const StyledActivePhotoContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const StyledInfoContainer = styled.div`
	width: 430px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	padding: 20px 20px 25px 20px;
	margin-top: 20px;
`;

const StyledInfoTable = styled.div`
	display: grid;
	grid-template-columns: 1fr auto;
	gap: 20px;
	align-items: center;

	div:nth-child(2n) {
		justify-self: end;
	}

	${Text} {
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledInfoTableCell = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;
`;

const StyledInputContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-top: 20px;
`;

const StyledShadow = styled.div`
	position: absolute;
	left: 50%;
	bottom: -550px;
	transform: translateX(-50%);
	width: 1100px;
	height: 1100px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export {
	StyledActivePhotoContainer,
	StyledContainer,
	StyledHeadBackSlot,
	StyledHeadContainer,
	StyledHeadCrossSlot,
	StyledInfoContainer,
	StyledInfoTable,
	StyledInfoTableCell,
	StyledInputContainer,
	StyledMainContainer,
	StyledShadow,
};
